import { TouchPointHelper } from '../../../helpers/touchPointHelper';
import { placeholders, displayGroups } from '@ui';

export const subscriptionTermsAndConditionsSoftware = {
	prismName: 'subscriptionTermsAndConditionsSoftware',
	template: {
		templateName: 'subscriptionTermsAndConditionsSoftwareTemplate',
		displayGroups: [
			TouchPointHelper.createDisplayGroup(displayGroups.pageContainer, [
				TouchPointHelper.createDisplayGroup(displayGroups.rowContainer, [
					TouchPointHelper.createDisplayGroup(
						displayGroups.leftPanel,
						[],
						[
							TouchPointHelper.createPlaceholder(placeholders.logo, {
								placeholderBuildReference: 10,
							}),
							TouchPointHelper.createPlaceholder(placeholders.wizardMenu, {
								placeholderBuildReference: 100,
							}),
							TouchPointHelper.createPlaceholder(placeholders.doubtsAndExit, {
								placeholderBuildReference: 200,
							}),
						]
					),
					TouchPointHelper.createDisplayGroup(
						displayGroups.columnContainer,
						[
							TouchPointHelper.createDisplayGroup(
								displayGroups.bodyPanel,
								[],
								[
									TouchPointHelper.createPlaceholder(placeholders.titleDocumentTermsCondition, {
										placeholderBuildReference: 100,
									}),
									TouchPointHelper.createPlaceholder(placeholders.cloudwareDocument, {
										placeholderBuildReference: 110,
									}),
									TouchPointHelper.createPlaceholder(placeholders.cloudwareDocumentDisclaimer, {
										placeholderBuildReference: 120,
									}),
								]
							),
						],
						[
							TouchPointHelper.createPlaceholder(placeholders.fixedFooter, {
								placeholderBuildReference: 1000,
							}),
							TouchPointHelper.createPlaceholder(placeholders.modals, {
								placeholderBuildReference: 10001,
							}),
						]
					),
				]),
			]),
		],
	},
};
